<template>
  <div>
    <v-row>
      <v-col>
        <v-textarea
          :value="notes"
          @input="triggerUpdateAndSaveFor('notes', $event)"
          label="Notas"
          outlined
          hide-details
          background-color="white"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>

    <v-card>
      <v-card-text>
        <h3 class="text-center mb-1">Acuidade Visual</h3>

        <SpinnerRow v-if="visualAcuityValuesLoading" class="py-4" />
        <v-row v-else>
          <v-col>
            <h3 class="mb-3 gray--text text-center">Sem correção</h3>

            <v-combobox
              :value="detranOverrides.without_correction.right_eye"
              :items="visualAcuityOptions"
              class="mb-2"
              label="Olho direito"
              dense
              outlined
              clearable
              hide-details
              background-color="white"
              :placeholder="visualAcuityPlaceholders.withoutCorrection.rightEye"
              :disabled="disableEdit"
              @input="
                updateDetranOverrides('without_correction', 'right_eye', $event)
              "
            />

            <v-combobox
              :value="detranOverrides.without_correction.left_eye"
              :items="visualAcuityOptions"
              label="Olho esquerdo"
              class="mb-2"
              dense
              outlined
              clearable
              hide-details
              background-color="white"
              :placeholder="visualAcuityPlaceholders.withoutCorrection.leftEye"
              :disabled="disableEdit"
              @input="
                updateDetranOverrides('without_correction', 'left_eye', $event)
              "
            />
          </v-col>
          <v-col>
            <h3 class="mb-3 gray--text text-center">Com correção</h3>

            <v-combobox
              :value="detranOverrides.with_correction.right_eye"
              :items="visualAcuityOptions"
              label="Olho direito"
              class="mb-2"
              dense
              outlined
              clearable
              hide-details
              background-color="white"
              :placeholder="visualAcuityPlaceholders.withCorrection.rightEye"
              :disabled="disableEdit"
              @input="
                updateDetranOverrides('with_correction', 'right_eye', $event)
              "
            />

            <v-combobox
              :value="detranOverrides.with_correction.left_eye"
              :items="visualAcuityOptions"
              label="Olho esquerdo"
              class="mb-2"
              dense
              outlined
              clearable
              hide-details
              background-color="white"
              :placeholder="visualAcuityPlaceholders.withCorrection.leftEye"
              :disabled="disableEdit"
              @input="
                updateDetranOverrides('with_correction', 'left_eye', $event)
              "
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import GET_ATTENDANCE_VISUAL_ACUITY_DATA from "@/components/medical_certificates/form/detran_fields/get_attendance_visual_acuity_data.gql";

import SpinnerRow from "@/components/ui/load_status/spinner-row.vue";

import { VISUAL_ACUITY_OPTIONS } from "@/components/medical_certificates/form/detran_fields/select_options.js";

export default {
  name: "MedicalCertificateFormDetranFields",
  components: { SpinnerRow },
  data() {
    return {
      visualAcuityOptions: VISUAL_ACUITY_OPTIONS,
    };
  },
  props: {
    attendanceId: {
      type: String,
      required: true,
    },
    notes: {
      type: String,
      required: false,
    },
    detranOverrides: {
      type: Object,
      required: false,
    },
    disableEdit: {
      type: Boolean,
      required: true,
    },
  },
  apollo: {
    attendanceVisualAcuityData: {
      query: GET_ATTENDANCE_VISUAL_ACUITY_DATA,
      update: (data) => data.attendance.visualAcuityData,
      fetchPolicy: "no-cache",
      variables() {
        return {
          attendanceId: this.attendanceId,
        };
      },
    },
  },
  computed: {
    visualAcuityValuesLoading() {
      if (!this.detranOverrides) return true;
      if (!this.attendanceVisualAcuityData) return true;

      return this.$apollo.queries.attendanceVisualAcuityData.loading;
    },
    visualAcuityPlaceholders() {
      return {
        withoutCorrection: {
          leftEye: this.visualAcuityPlaceholderValue(
            this.attendanceVisualAcuityData.without_correction.left_eye
          ),
          rightEye: this.visualAcuityPlaceholderValue(
            this.attendanceVisualAcuityData.without_correction.right_eye
          ),
        },
        withCorrection: {
          leftEye: this.visualAcuityPlaceholderValue(
            this.attendanceVisualAcuityData.with_correction.left_eye
          ),
          rightEye: this.visualAcuityPlaceholderValue(
            this.attendanceVisualAcuityData.with_correction.right_eye
          ),
        },
      };
    },
  },
  methods: {
    visualAcuityPlaceholderValue(value) {
      return value || "Em branco";
    },
    triggerUpdateAndSaveFor(syncedProp, value) {
      this.$emit(`update:${syncedProp}`, value);
      this.$emit("save");
    },
    updateDetranOverrides(correction_type, eye_position, value) {
      // null is used as a fallback so that the new override is not ignored on merge
      const newValue = value || null;

      const newOverride = { [correction_type]: { [eye_position]: newValue } };

      const detranOverrides = this.lodash.merge(
        this.detranOverrides,
        newOverride
      );

      this.triggerUpdateAndSaveFor("detranOverrides", detranOverrides);
    },
  },
};
</script>

<style scoped></style>
